
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { LinkGrid } from '../../app/components';
import { links } from '../../__configuration__/community';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* KEYWORDS: bugs feature request questions team license innersource contact community  */
    }
    <h1>{`Community`}</h1>
    <p>{`Brightlayer UI is an open source design system that thrives on having an active and engaged community of maintainers and contributors. Check out the links below to learn more about our team and how you can be a part of the community.`}</p>
    <LinkGrid links={links} style={{
      marginTop: 32
    }} mdxType="LinkGrid" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;